import { render, staticRenderFns } from "./color-widget.vue?vue&type=template&id=e8d0abee&scoped=true"
import script from "./color-widget.vue?vue&type=script&lang=js"
export * from "./color-widget.vue?vue&type=script&lang=js"
import style0 from "./color-widget.vue?vue&type=style&index=0&id=e8d0abee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d0abee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8d0abee')) {
      api.createRecord('e8d0abee', component.options)
    } else {
      api.reload('e8d0abee', component.options)
    }
    module.hot.accept("./color-widget.vue?vue&type=template&id=e8d0abee&scoped=true", function () {
      api.rerender('e8d0abee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/color-widget.vue"
export default component.exports